const moduleName = 'animate';

const inView = require('in-view');

module.exports = () => {

    Array.from(document.querySelectorAll('.js-animate')).forEach((self) => {
        if (self.dataset[moduleName + 'Init'] === 'true') return;
        self.dataset[moduleName + 'Init'] = true;

        const target = self;

        inView.offset({
            top: 100,
            right: 0,
            bottom: 100,
            left: 0
        });

        checkTargetVisibility();

        document.addEventListener('scroll', checkTargetVisibility);

        function checkTargetVisibility() {
            if (inView.is(target) && !target.classList.contains('_animated')) {
                target.classList.add('_animated');
            }
        }
    });

};